jQuery(function ($) {
	$('.legacyFixed-btn').click(function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
		} else {
			$(this).addClass('active');
		}
	});
	$('.legacyFixed-btn').blur(function () {
		$(this).removeClass('active');
	});
	//Popover Function
	$('[data-toggle="popover"]').popover({
		trigger: 'click',
		placement: 'left',
		html: 'true',
		content: '<div class="text-center">Can&#39;t find what you&#39;re looking for&#63;<br><a href="https://www.afrwholesale.com/" target="_blank">Visit Our Legacy Site</a></div>'
	});
});







// WEBPACK FOOTER //
// ./scripts/old/popover.js